import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react';

import { Colors } from '../../../utils/common';

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';

const MissionReactSlick = ({
  id,
  sliderImages,
}: {
  id: string;
  sliderImages: string[];
}) => {
  const swiperSettings: SwiperProps = {
    modules: [Autoplay, Pagination],
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      clickable: true,
    },
    style: {
      '--swiper-pagination-color': Colors.Gray[400],
      '--swiper-pagination-bullet-inactive-color': Colors.Gray[200],
      '--swiper-pagination-bottom': '0px',
      '--swiper-pagination-bullet-inactive-opacity': '1',
    } as React.CSSProperties,
  };

  return (
    <div id={id}>
      <Swiper {...swiperSettings}>
        {sliderImages.map((imageUrl, i) => (
          <SwiperSlide key={imageUrl}>
            <img
              src={imageUrl}
              alt={`슬라이더 이미지 ${i}`}
              className="mx-auto"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default MissionReactSlick;
